import React from 'react';
import MaterialIcon from 'material-icons-react';
import { Col } from 'reactstrap';

const OrderDetailsIcon = (props) => {
    return (
        <Col xs={6} style={props.styles.screenTitleContainer} hidden={props.hidden}>
            <div><MaterialIcon icon={props.iconType} color="#0288d1" />{props.textContent}</div>
        </Col>
    )
}

export default OrderDetailsIcon;


// WEBPACK FOOTER //
// ./src/components/restaurants/orders/orderDetailsCommon/OrderDetailsIcon.js